import { LoginGate } from "./auth/LoginGate";
import { SessionProvider } from "./session/SessionProvider";
import { Header } from "./components/Header";
import { Stepper } from "./components/Stepper";
import { StepContainer } from "./components/StepContainer";

/**
 * App raíz. Solo orquestación — ningún state ni lógica propia.
 *
 * Estructura:
 *   AuthProvider (en main.jsx, no aquí)
 *     └─ LoginGate (bloquea si no autenticado)
 *          └─ SessionProvider (solo crea sesión si hay user)
 *               └─ Layout: Header + Stepper + contenido del paso actual
 *
 * Cada componente hijo consume lo que necesita vía useAuth() o useSession()
 * — App no le pasa ningún prop sobre auth o estado.
 */
export default function App() {
  return (
    <LoginGate>
      <SessionProvider>
        <div style={styles.app}>
          <Header />
          <Stepper />
          <main style={styles.main}>
            <StepContainer />
          </main>
        </div>
      </SessionProvider>
    </LoginGate>
  );
}

const styles = {
  app: {
    minHeight: "100vh",
    background: "#f8f7ff",
    fontFamily: "'Georgia', serif",
  },
  main: {
    padding: "0",
  },
};
